import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_base_button = _resolveComponent("bs5-base-button")!

  return (_openBlock(), _createBlock(_component_bs5_base_button, {
    variant: "danger",
    size: "sm",
    loading: _ctx.loading
  }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "bi bi-trash" }, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t("common.delete")), 1)
    ]),
    _: 1
  }, 8, ["loading"]))
}